module.exports = __webpack_public_path__ + "assets/img/mr9.2d5d8ed7.png";